<template>
  <template v-if="isAdmin">
    <!-- Active window -->
    <v-alert
      v-if="current && !current.available"
      type="error"
      variant="tonal"
      class="admin-maintenance-banner mx-4 my-2"
    >
      <strong>EMS maintenance is active.</strong>
      <template v-if="current.reason === 'health-check-failure'">
        &nbsp;Unplanned outage detected by health check. Cloud transactions are blocked.
      </template>
      <template v-else-if="current.scheduledEnd">
        &nbsp;Ends {{ formatUtc(current.scheduledEnd) }} ({{ formatLocal(current.scheduledEnd) }}).
      </template>
    </v-alert>

    <!-- Upcoming scheduled window -->
    <v-alert v-else-if="adminUpcoming" type="warning" variant="tonal" class="admin-maintenance-banner mx-4 my-2">
      <strong>Upcoming EMS maintenance:</strong>
      &nbsp;{{ formatUtc(adminUpcoming.startsAtUtc) }} – {{ formatUtc(adminUpcoming.endsAtUtc) }} ({{
        formatLocal(adminUpcoming.startsAtUtc)
      }}
      local)
    </v-alert>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import store from '@/store';
import type { MaintenanceInfo, MaintenanceWindowDto } from '@/store/modules/maintenance';

const isAdmin = computed<boolean>(() => store.getters['login/isAdmin']);
const current = computed<MaintenanceInfo | null>(() => store.getters['maintenance/adminCurrent']);
const adminUpcoming = computed<MaintenanceWindowDto | null>(() => store.getters['maintenance/adminUpcoming']);

function formatUtc(iso: string): string {
  return `${new Date(iso).toLocaleString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })} UTC`;
}

function formatLocal(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  });
}
</script>
